module.exports = {
  title: `Blog`,
  description: `Personal Blog`,
  author: `Abhijeet`,
  introduction: `I explain with words and code.`,
  siteUrl: `https://gatsby-starter-bee.netlify.com`, // Your blog site url
  social: {
    twitter: `abhianuj10`, // Your Twitter account
    github: `abhianuj`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: `abhijeet-kumar-189180171`, // Your LinkedIn account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'abhianuj/my-blog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '203624877646836', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-171621970-1', // Add your google analytics tranking ID
}